
<script>
	import { Line } from 'vue-chartjs'

	export default {
		data(){
			return{
				opcoes:{
					responsive: true,
					maintainAspectRatio: false,
					scales: {
						yAxes: [{
							ticks: {
								callback: (valor)=>{return 'R$ '+valor;}
							}
						}]
					}
				},
			}
		},
		props: {
			parcelas: {
				required: true,
				type: Array
			},
			parcelasCDI: {
				required: true,
				type: Array
			}
		},
		extends: Line,
		watch: {
			dados() {
				this.renderLineChart();
			}
		},
		computed:{
			dados(){
				if(this.parcelas != undefined && this.parcelasCDI != undefined){
					let labels = []
					let data = []
					let dataCDI = []
					this.parcelas.map(item => {
						labels = [...labels, "Mês "+item.mes]
						data = [ ...data, item.valorAcumulativo]
					})
					this.parcelasCDI.map(item => {
						dataCDI = [ ...dataCDI, item.valorAcumulativo]
					})
					return {
						labels,
						// Estilo da linha
						datasets: [
							{
								label: 'IOUU',
								fill:false,
								borderColor: '#41D3BD',
								backgroundColor: '#41D3BD',
								pointBorderWidth: 3,
								pointBackgroundColor: '#41D3BD',
								data
							},
							{
								label: 'CDB',
								fill:false,
								borderColor: '#6FC30D',
								backgroundColor: '#6FC30D',
								pointBorderWidth: 3,
								pointBackgroundColor: '#6FC30D',
								data: dataCDI
							}
						]
					}
				}
				return ''
			},
		},
		methods: {
			renderLineChart(){ this.renderChart(this.dados,this.opcoes) }
		},
		mounted() {
			this.renderLineChart();
		},
	}
</script>





// WEBPACK FOOTER //
// src/components/charts/LineChartInvestment.vue